import { schema } from 'normalizr';
import { Participant } from '@app/api';
import { i18n } from 'i18n';

export enum ParticipantSource {
  SESSION = 'SESSION',
  MANUAL_ADDITION = 'MANUAL_ADDITION',
  STANDALONE_FORM = 'STANDALONE_FORM',
}

export enum StudySubjectPreference {
  B2B = 'B2B',
  B2C = 'B2C',
}

export enum StudyTypePreference {
  PHYSICAL = 'PHYSICAL',
  REMOTE = 'REMOTE',
  UNMODERATED = 'UNMODERATED',
}

export enum ProfessionalSituation {
  WORKING = 'WORKING',
  STUDENT = 'STUDENT',
  LOOKING_FOR_JOB = 'LOOKING_FOR_JOB',
  UNEMPLOYED = 'UNEMPLOYED',
  RETIRED = 'RETIRED',
}

export interface ParticipantTag {
  id: string;
  name: string;
  color: string;
  panelId: string;

  deletedAt?: string;
}

export const PARTICIPANT_ENTITY_NAME = 'participants';
export const PARTICIPANT_TAGS_ENTITY_NAME = 'participantTags';

export const participantLinkedEntities = [
  PARTICIPANT_ENTITY_NAME,
  PARTICIPANT_TAGS_ENTITY_NAME,
];
export const participantTagsLinkedEntities = [PARTICIPANT_TAGS_ENTITY_NAME];

export const participantTagsSchema = new schema.Entity(
  PARTICIPANT_TAGS_ENTITY_NAME,
);

export const participantSchema = new schema.Entity(
  PARTICIPANT_ENTITY_NAME,
  {
    tags: new schema.Array(participantTagsSchema),
  },
  {
    processStrategy: (value: Participant): Participant => {
      if (!value.deletedAt) {
        return { ...value };
      }
      return {
        ...value,
        fullName: i18n.t('participants.deleted'),
        firstName: i18n.t('participants.deleted'),
        lastName: i18n.t('participants.deleted'),
        email: i18n.t('participants.deleted'),
        phoneNumber: null,
      };
    },
  },
);
